import { createSlice } from "@reduxjs/toolkit";
import { THEMES } from "../../constants/app.constants.js";

const initialState = {
  theme: localStorage.getItem("theme") || THEMES.SYSTEM,
  notifications: {
    email: true,
    push: true,
    inApp: true,
  },
  language: "en",
  isLoading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem("theme", action.payload);
    },
    toggleNotification: (state, action) => {
      const { type } = action.payload;
      if (type in state.notifications) {
        state.notifications[type] = !state.notifications[type];
      }
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    clearSettingsError: (state) => {
      state.error = null;
    },
  },
});

export const { setTheme, toggleNotification, setLanguage, clearSettingsError } =
  settingsSlice.actions;

export default settingsSlice.reducer;
